export default __webpack_public_path__ + "static/media/firstBg.b3561f64.png";